'use client';
import { objectKeys } from '../object/object.js';

const { from } = Array;
/**
 * Type-safe обёртка над `Array.isArray`.
 *
 * @typeParam T - Тип элемента массива.
 * @typeParam R - Представляющий массив тип.
 *
 * @param subject - Субъект проверки произвольного типа.
 *
 * @primaryExample
 * isArray({}) // false
 * isArray([]) // true
 *
 * @stable
 * */ const isArray = (subject)=>Array.isArray(subject);
/**
 * Возвращает массив индексов исходного массива.
 *
 * @typeParam T - Тип элемента массива.
 * @param array - Исходный массив.
 * @returns Массив индексов исходного массива.
 *
 * @primaryExample
 * arrayKeys(['a', 'b', 'c']) // [1, 2, 3]
 *
 * @stable
 * */ const arrayKeys = (array)=>objectKeys(array).map(Number);
/**
 * Возвращает последний элемент массива.
 *
 * @typeParam T - Тип элемента массива.
 * @param array - Исходный массив.
 * @returns Последний элемент массива.
 *
 * @primaryExample
 * arrayKeys(['a', 'b', 'c']) // 'c'
 *
 * @stable
 * */ const arrayLast = (array)=>array[arrayLastIndex(array)];
/**
 * Возвращает индекс последнего элемента массива.
 *
 * @typeParam T - Тип элемента массива.
 * @param array - Исходный массив.
 * @returns Индекс последнего элемента.
 *
 * @stable
 * */ const arrayLastIndex = (array)=>Math.max(0, array.length - 1);
/**
 * Проверяет, является ли переданное число последним индексом массива.
 *
 * @typeParam T - Тип элемента массива.
 * @param array - Исходный массив.
 *
 * @stable
 * */ const arrayIsLastIndex = (array, index)=>index === arrayLastIndex(array);
/**
 * Генерирует массив чисел длины `n`, где каждое следующее значение на `1` больше предыдущего.
 *
 * @typeParam T - Тип элемента массива.
 * @param n - Длина генерируемого массива.
 * @param startAt {0} - Значение первого элемента.
 * @returns Массив чисел.
 *
 * @stable
 * */ const arrayFromNumber = (n, startAt = 0)=>from(Array(n), (_, i)=>startAt + i);
/**
 * То же самое, что и `Array.from`.
 * @stable
 * */ const arrayFrom = from;

export { arrayFrom, arrayFromNumber, arrayIsLastIndex, arrayKeys, arrayLast, arrayLastIndex, isArray };
//# sourceMappingURL=array.js.map
